import { useTranslation } from 'react-i18next';
import { useMutation, useQueryClient } from 'react-query';

import { QUERY_KEYS } from 'consts/queryKeys';
import { useCustomToast } from 'hooks';
import { updateBasicAutomationTrigger } from 'modules/settings/api';

export const useMutationBasicAutomationTrigger = () => {
  const queryClient = useQueryClient();
  const { t } = useTranslation();
  const { successToast, errorToast } = useCustomToast();

  return useMutation(updateBasicAutomationTrigger, {
    onSuccess: () => {
      successToast();
      queryClient.refetchQueries(QUERY_KEYS.SETTINGS_BASIC_AUTOMATION);
    },
    onError: () => {
      errorToast();
    },
  });
};
